"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayNumberNone = displayNumberNone;
/**
 * Function to format a given string
 *
 * Remove trailing zeros if '.00'
 * @param {any} input - The value to be formatted.
 * @returns {string} - Return formatted string
 */
const displayNumberFromBE_1 = require("./displayNumberFromBE");
function displayNumberNone(val, language) {
    if (val === undefined) {
        return "--";
    }
    if (val.valueInMinUnit === 0) {
        return language.none;
    }
    // remove trailing zeros if '.00'
    return (0, displayNumberFromBE_1.displayNumberFromBE)(val);
}
